import React, { useEffect } from "react";

import "../../../../style/create-new-app-env.module.css";
import "../../../../style/license-key-modal.module.css";
import saasAnalytics from "../../../../dashboard/saas/saasAnalytics";

type CreateAnAppFirstProps = {
    onCloseModal: () => void;
};

export default function CreateAnAppFirst({ onCloseModal }: CreateAnAppFirstProps) {
    useEffect(() => {
        saasAnalytics.enablePaidFeaturesCreateAppBeforeGeneratingLicenseKey();
    }, []);
    return (
        <div className="modal-container max-content">
            <div className="modal-header">
                <h2>Create an App!</h2>
                <span
                    className="close-btn"
                    onClick={() => {
                        saasAnalytics.enablePaidFeaturesModalClose("create-an-app-first");
                        onCloseModal();
                    }}
                >
                    <img src="static/assets/dashboard/close-rounded.png" />
                </span>
            </div>
            <div className="modal-body">
                <div className="info-blue-container">
                    <span className="info-blue-pill">Info</span>
                    <p>
                        You need to <span className="weight-500">Create an App</span> first to enable the paid features
                        for Managed service.
                    </p>
                    <p>For app creation Enter the Auth method and Setup details in get started section.</p>
                </div>
            </div>
            <div className="modal-action-container margin-top-20">
                <button
                    onClick={() => {
                        saasAnalytics.enablePaidFeaturesModalClose("create-an-app-first");
                        onCloseModal();
                    }}
                    className={`yellow-button-loading btn btn-sm yellow-button`}
                >
                    Continue
                </button>
            </div>
        </div>
    );
}
